import { isStoreAdmin, isSuperAdmin } from '@/lib/roles'

/** Post-login home path for the current user type. */
export const homePathForType = (type?: string | null) => {
	if (isSuperAdmin(type)) return '/super-admin'
	if (isStoreAdmin(type)) return '/admin-panel'
	return '/customer/overview'
}
